"use-strict";

import 'jquery';

export class Token{
    constructor() {
        this.csrfToken = null;

        setTimeout(() => {
            this.getToken();
        }, 2000);
    }

    getToken() {
        $.ajax('/csrfToken').done((data) => {
            const key = 'csrf_token';
            if (data && typeof data[key] === 'string') {
                this.csrfToken = data[key];
                this.updateMetaTag();
                this.updateHiddenFields();
            }
        });
    }

    updateMetaTag() {
        $('#meta-csrf-token').attr('content', this.csrfToken);
    }

    updateHiddenFields() {
        $('input[type="hidden"][name="_token"]').val(this.csrfToken);
    }
}

